var React = require('react');

function Street (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M8.1 2h4.21a.5.5 0 0 1 .487.385l3.058 13a.5.5 0 0 1-.486.615H2.747a.5.5 0 0 1-.463-.69l5.353-13A.5.5 0 0 1 8.1 2z","fill":"#9AA4B4","key":0}),React.createElement("path",{"d":"M9.57 5.707h.848l-.322 4.036H8.928l.643-4.036H9.57zm.092-.577l.245-1.538h.679l-.122 1.538h-.802zm-.856 5.382h1.23l-.31 3.887H8.187l.619-3.887zm1.223-7.688h.618-.618z","fill":"#F2F3F4","fillRule":"nonzero","key":1})]));
}

Street.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19"};

module.exports = Street;

Street.default = Street;
